import React from 'react';
import PropTypes from 'prop-types';
import {
    ButtonSecondary,
    CollapsiblePanel,
    CollapsiblePanelBody,
    CollapsiblePanelHeader,
    Fields,
    HighlightedSection,
    HorizontalFlex,
    Input,
} from 'smartsuite-ui';
import TimeAndPrecisionSelector from '../shared/filtering/TimeAndPrecisionSelector';
import { useLabelContext } from '../shared/hooks/labelContext';
import { standardPredefinedDateRanges } from '../shared/constants/constants';

// eslint-disable-next-line complexity
export default function CustomDashboardCriteria(props) {
    const { dashboardLabels, translationLabels } = useLabelContext();

    return (
        <CollapsiblePanel
            isCollapsed={props.isCollapsed}
            onCollapse={props.onCollapse}
        >
            <CollapsiblePanelHeader
                autoHideRollupText={false}
                headerLabel={dashboardLabels.dashboardFilters}
                rollupText={props.rollupText}
            >
                {!props.isReadOnly && (
                    <HorizontalFlex cssClassModifiers={['justify-flex-end']}>
                        <ButtonSecondary
                            disabled={
                                props.hasErrors ||
                                (!props.hasPendingChanges &&
                                    !props.isCreateMode)
                            }
                            onClick={props.saveDashboard}
                        >
                            <span>{translationLabels.save}</span>
                        </ButtonSecondary>
                    </HorizontalFlex>
                )}
            </CollapsiblePanelHeader>
            <CollapsiblePanelBody>
                <HighlightedSection>
                    {!props.isReadOnly && (
                        <Fields>
                            <Input
                                disabled={props.isReadOnly}
                                label={dashboardLabels.dashboardName}
                                value={props.dashboardName || ''}
                                onChange={(e) =>
                                    props.setDashboardName(e.target.value)
                                }
                                isValid={!!props.dashboardName}
                            />
                        </Fields>
                    )}
                    <TimeAndPrecisionSelector
                        disabled={props.isReadOnly}
                        isGauge={false}
                        predefinedDateRanges={standardPredefinedDateRanges}
                        saveTimeAndPrecision={
                            props.setDashboardTimeAndPrecision
                        }
                        showPrecisionConfig={true}
                        showTimeAndPrecision={true}
                        timeAndPrecision={props.dashboardTimeAndPrecision}
                    />
                </HighlightedSection>
            </CollapsiblePanelBody>
        </CollapsiblePanel>
    );
}

CustomDashboardCriteria.propTypes = {
    dashboardName: PropTypes.string,
    dashboardTimeAndPrecision: PropTypes.instanceOf(Object).isRequired,
    hasErrors: PropTypes.bool,
    hasPendingChanges: PropTypes.bool,
    isCollapsed: PropTypes.bool.isRequired,
    isCreateMode: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    onCollapse: PropTypes.func.isRequired,
    rollupText: PropTypes.string,
    saveDashboard: PropTypes.func,
    setDashboardName: PropTypes.func,
    setDashboardTimeAndPrecision: PropTypes.func,
};
